import { QueryClient } from '@tanstack/react-query';
import { ApiResult } from '../../models/ApiResult';
import { staleTimeForSession } from '../reactQueryCore';
import useCustomQuery from '../useCustomQuery';
import { get, post } from './ApiWrapper';
import useCustomMutation from '../useCustomMutation';

const basePath = 'files';
const profileFileStringQueryKey = [basePath, 'profile'];

export const useProfileFileString = () => {
	return useCustomQuery({
		queryKey: profileFileStringQueryKey,
		queryFn: (): Promise<string> => get(`${basePath}/profile`),
		staleTime: staleTimeForSession,
		refetchOnMount: false,
		refetchOnReconnect: false,
		refetchOnWindowFocus: false
	});
};

export const useUpdateProfilePhoto = (queryClient: QueryClient) => {
	return useCustomMutation({
		mutationFn: (formData: FormData): Promise<void> => post(`${basePath}/profile`, formData, null, true, false),
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: profileFileStringQueryKey });
		}
	});
};

export const getInvoiceFileString = async (
	invoiceId: number,
	email: string,
	signal?: AbortSignal
): Promise<ApiResult<string>> => {
	return get(`${basePath}/invoices/${invoiceId}?email=${email}`, signal);
};
